module.exports = __webpack_public_path__ + "static/media/logomark-final-dark-theme.139cf060.svg";